<template>
  <div class="container">
    <vue-particles
      id="tsparticles"
      :particlesInit="particlesInit"
      :particlesLoaded="particlesLoaded"
      :options="nasaParticle"
    />
    <Card class="login-card">
      <template #header>
        <img
          class="logo"
          height="30"
          width="30"
          :src="logo"
          alt="Autogestión"
        />
      </template>
      <template #subtitle>
        <h3 class="text-center">Recuperar contraseña</h3>
      </template>
      <template #content class="padding-2">
        <Steps :model="items" aria-label="Form Steps" />
        <router-view
          v-slot="{ Component }"
          :formData="formObject"
          @prevPage="prevPage($event)"
          @nextPage="nextPage($event)"
          @complete="complete"
        >
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </template>
    </Card>
  </div>
</template>
<script setup lang="ts">
  import { loadSlim } from 'tsparticles-slim'
  import { nasaParticle } from '@/assets/particles/nasa'
  import { computed, ref } from 'vue'
  import { onMounted } from 'vue'
  import { useField } from 'vee-validate'
  import * as yup from 'yup'
  import logo from '../../../assets/logo_new_res.png'
  import { useUserStore } from '@/store/user'
  import { useRouter, RouterView } from 'vue-router'
  import useNotifications from '@/store/notification'
  import { useToast } from 'primevue/usetoast'

  import {
    sendRecoveryCode,
    confirmAndChangePassword,
  } from '../services/authentication'
  const notificationStore = useNotifications()
  const userStore = useUserStore()
  const router = useRouter()

  const email = ref()

  const items = ref([
    {
      label: 'Correo',
      to: '/forgotPassword/email',
    },
    {
      label: 'Confirmar código',
      to: '/forgotPassword/confirmCode',
    },
  ])

  const formObject: any = ref({})

  const nextPage = async (event: any) => {
    for (let field in event.formData) {
      formObject.value[field] = event.formData[field]
    }

    if (String(event.pageIndex) === '0') {
      email.value = formObject.value.email
      const response = await sendRecoveryCode(formObject.value.email)
      if (response === 'OK') {
        notificationStore.addSuccesNotification({
          detail: `200`,
          severity: 'success',
          summary: `¡Código enviado con exito!`,
        })
        router.push(items.value[event.pageIndex + 1].to)
      }
    }

    if (String(event.pageIndex) === '1') {
      const response = await confirmAndChangePassword({
        email: formObject.value.email,
        code: formObject.value.code,
        newPassword: formObject.value.newPassword,
      })

      if (response === 'OK') {
        notificationStore.addSuccesNotification({
          detail: `200`,
          severity: 'success',
          summary: `¡La contraseña ha sido cambiada con exito!`,
        })

        complete()
      }
    }
  }

  const prevPage = (event: any) => {
    router.push(items.value[event.pageIndex - 1].to)
  }

  const complete = () => {
    router.push('/login')
  }

  const particlesInit = async (engine: any) => {
    await loadSlim(engine)
  }

  const particlesLoaded = async (container: any) => {}
</script>
<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    height: auto;
    background-color: #f8f9fa;
    /* background-image: url('../../../assets/LinePattern_login.svg'); */
  }

  .login-card {
    width: 30em;
    min-height: 3em;
    height: auto;
    padding-top: 1rem;
    z-index: 9;
  }

  .logo {
    width: 100%;
    object-fit: contain;
    height: 80px;
  }

  #login-form {
    display: flex;
    flex-flow: column wrap;
    text-align: left;
  }

  Button {
    display: block;
  }

  label {
    padding-bottom: 5px;
  }

  ::v-deep(b) {
    display: block;
  }

  ::v-deep(.p-card-body) {
    padding: 2rem;
  }

  .error-message {
    padding-top: 5px;
    color: rgb(234, 68, 68);
    font-size: 12px;
  }

  ::v-deep(.p-card-body) {
    padding: 0px;
  }
</style>
